import { combineEpics } from 'redux-observable';
// ---- external imports ----

import onStartNextTurnEpic from './onStartNextTurnEpic';
// ---- local imports ----


export default combineEpics(
	onStartNextTurnEpic,
);
